import React from 'react'
import { SearchIcon } from '../Icons'
import { Text } from '../Text'

export interface EmptyStateProps {
  title?: string
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
  image?: React.ReactNode
}

export function EmptyState({
  title = 'No items found',
  description = 'Try changing the filters or search term',
  action,
  image,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center bg-background border-b border-border">
      <div className="mb-6 text-border">{image || <SearchIcon className="w-12 h-12 text-muted-foreground" />}</div>
      <Text as="h3" size="body" spacing="tight" className="font-[650]">
        {title}
      </Text>
      <Text size="body-small" color="subdued" className="max-w-sm mb-6">
        {description}
      </Text>
      {action && (
        <button
          onClick={action.onClick}
          className="px-4 py-2 text-sm font-medium text-white bg-[#008060] rounded shadow-sm hover:bg-[#006E52] transition-colors focus:ring-2 focus:ring-offset-2 focus:ring-[#008060]"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
